import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'combo' | 'base'>('combo');
  const ctaPrice = selected === 'combo' ? '$29.990' : '$19.990';
  const ctaLink = selected === 'combo' ? 'https://fegion.shop/cart/46280115159179:1' : 'https://fegion.shop/cart/46280111620235:1';
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" id="pricing" data-id="element-146">
      {/* Header */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-147">
        <h2 className="text-3xl md:text-5xl font-bold italic text-white font-heading mb-4 tracking-wider uppercase" data-id="element-148">
          ELEGÍ TU OPCIÓN
        </h2>
        <p className="text-[#a0aec0] text-lg" data-id="element-149">
          Seleccioná el pack que mejor se adapte a tu estudio.
        </p>
      </motion.div>

      {/* Radio Card Selector */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="max-w-md mx-auto mb-16" data-id="element-150">
        <div className="bg-[#0b1a30] rounded-2xl border border-[#1a2b4c] overflow-hidden" data-id="element-151">
          {/* COMBO PRO Option */}
          <button type="button" onClick={() => setSelected('combo')} className={`w-full text-left p-5 md:p-6 transition-colors relative ${selected === 'combo' ? 'border-l-4 border-l-green-500 bg-green-500/5' : 'border-l-4 border-l-transparent'}`} data-id="element-152">
            <div className="flex items-start gap-3" data-id="element-153">
              {/* Radio */}
              <div className="mt-1 shrink-0" data-id="element-154">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-green-500 bg-green-500' : 'border-[#4a5568]'}`} data-id="element-155">
                  {selected === 'combo' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-156" />}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-157">
                <div className="flex items-start justify-between gap-3" data-id="element-158">
                  <div data-id="element-159">
                    <div className="flex items-center gap-2 mb-1" data-id="element-160">
                      <span className="text-lg" data-id="element-161">🏆</span>
                      <span className="text-white font-bold text-lg md:text-xl tracking-wide" data-id="element-162">
                        COMBO ÉLITE AT
                      </span>
                    </div>
                  </div>
                  <div className="text-right shrink-0" data-id="element-163">
                    <div className="text-[#a0aec0] line-through text-sm" data-id="element-164">
                      $39.980
                    </div>
                    <div className="text-white font-bold text-2xl md:text-3xl" data-id="element-165">
                      $29.990
                    </div>
                  </div>
                </div>

                {/* Badges */}
                <div className="flex flex-wrap gap-2 mt-3 mb-4" data-id="element-166">
                  <span className="inline-flex items-center gap-1 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-167">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="inline-flex items-center gap-1 border border-green-500 text-green-400 text-xs font-bold px-3 py-1 rounded-full" data-id="element-168">
                    AHORRAS $10.000
                  </span>
                </div>

                {/* Description */}
                <p className="text-[#e2e8f0] text-sm mb-1" data-id="element-169">
                  8 módulos + 4 bonos
                </p>
                <p className="text-white font-bold text-sm mb-2" data-id="element-170">
                  + El Cerebro Clínico del AT
                </p>
                <div className="space-y-0.5" data-id="element-171">
                  <p className="text-[#718096] text-xs" data-id="element-172">
                    - El Traductor de Clínica
                  </p>
                  <p className="text-[#718096] text-xs" data-id="element-173">
                    - Hojas de Ruta 30 Días
                  </p>
                  <p className="text-[#718096] text-xs" data-id="element-174">
                    - Protocolo Legal de Cobro
                  </p>
                  <p className="text-[#718096] text-xs" data-id="element-175">- Crisis Nivel 2</p>
                  <p className="text-[#718096] text-xs" data-id="element-176">- Vademécum del AT</p>
                </div>
              </div>
            </div>
          </button>

          {/* Divider */}
          <div className="border-t border-[#1a2b4c]" data-id="element-177" />

          {/* PACK BASE Option */}
          <button type="button" onClick={() => setSelected('base')} className={`w-full text-left p-5 md:p-6 transition-colors relative ${selected === 'base' ? 'border-l-4 border-l-green-500 bg-green-500/5' : 'border-l-4 border-l-transparent'}`} data-id="element-178">
            <div className="flex items-center gap-3" data-id="element-179">
              {/* Radio */}
              <div className="shrink-0" data-id="element-180">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'base' ? 'border-green-500 bg-green-500' : 'border-[#4a5568]'}`} data-id="element-181">
                  {selected === 'base' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-182" />}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0 flex items-center justify-between gap-3" data-id="element-183">
                <div data-id="element-184">
                  <div className="flex items-center gap-2" data-id="element-185">
                    <span className="text-lg" data-id="element-186">💚</span>
                    <span className="text-white font-bold text-lg tracking-wide" data-id="element-187">
                      PACK BASE AT
                    </span>
                  </div>
                  <p className="text-[#a0aec0] text-sm mt-0.5" data-id="element-188">
                    8 módulos + 4 bonos
                  </p>
                </div>
                <div className="text-right shrink-0" data-id="element-189">
                  <div className="text-[#a0aec0] line-through text-sm" data-id="element-190">
                    $59.920
                  </div>
                  <div className="text-white font-bold text-2xl md:text-3xl" data-id="element-191">
                    $19.990
                  </div>
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <motion.a href={ctaLink} target="_blank" rel="noopener noreferrer" whileTap={{
        scale: 0.97
      }} onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout', {
            value: selected === 'combo' ? 29990 : 19990,
            currency: 'ARS',
            content_name: selected === 'combo' ? 'Combo Elite AT' : 'Pack Base AT'
          });
        }
      }} className="mt-6 flex items-center justify-center gap-2 w-full py-5 px-6 bg-green-600 hover:bg-green-500 text-white rounded-2xl font-bold text-lg md:text-xl transition-colors shadow-lg shadow-green-600/20" data-id="element-192">
          <span data-id="element-193">EMPEZAR HOY —</span>
          <span data-id="element-194">💚</span>
          <span data-id="element-195">{ctaPrice}</span>
        </motion.a>
      </motion.div>

      {/* Comparison Table */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="max-w-3xl mx-auto" data-id="element-196">
        <h4 className="text-center text-xl text-white font-bold mb-6" data-id="element-197">
          COMPARATIVA COMPLETA
        </h4>
        <div className="bg-[#0f1d36] rounded-2xl border border-[#1a2b4c] overflow-hidden" data-id="element-198">
          <div className="grid grid-cols-3 bg-[#0a1628] border-b border-[#1a2b4c] p-4" data-id="element-199">
            <div data-id="element-200"></div>
            <div className="text-center font-bold text-[#a0aec0]" data-id="element-201">BASE</div>
            <div className="text-center font-bold text-[#d4af37]" data-id="element-202">ELITE</div>
          </div>
          <div className="divide-y divide-[#1a2b4c]" data-id="element-203">
            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-204">
              <div className="text-[#e2e8f0] font-medium" data-id="element-205">8 Módulos</div>
              <div className="text-center flex justify-center items-center" data-id="element-206">
                <Check className="w-5 h-5 text-green-400" data-id="element-207" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-208">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-209" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-210">
              <div className="text-[#e2e8f0] font-medium" data-id="element-211">4 Bonos</div>
              <div className="text-center flex justify-center items-center" data-id="element-212">
                <Check className="w-5 h-5 text-green-400" data-id="element-213" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-214">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-215" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-216">
              <div className="text-[#e2e8f0] font-medium" data-id="element-217">El Traductor</div>
              <div className="text-center flex justify-center items-center" data-id="element-218">
                <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-219" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-220">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-221" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-222">
              <div className="text-[#e2e8f0] font-medium" data-id="element-223">Hojas de Ruta</div>
              <div className="text-center flex justify-center items-center" data-id="element-224">
                <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-225" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-226">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-227" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-228">
              <div className="text-[#e2e8f0] font-medium" data-id="element-229">Protocolo Legal</div>
              <div className="text-center flex justify-center items-center" data-id="element-230">
                <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-231" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-232">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-233" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-234">
              <div className="text-[#e2e8f0] font-medium" data-id="element-235">Crisis Nivel 2</div>
              <div className="text-center flex justify-center items-center" data-id="element-236">
                <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-237" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-238">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-239" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-240">
              <div className="text-[#e2e8f0] font-medium" data-id="element-241">Vademécum AT</div>
              <div className="text-center flex justify-center items-center" data-id="element-242">
                <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-243" />
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-244">
                <Check className="w-5 h-5 text-[#d4af37]" data-id="element-245" />
              </div>
            </div>

            <div className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-246">
              <div className="text-[#e2e8f0] font-medium" data-id="element-247">Precio</div>
              <div className="text-center flex justify-center items-center" data-id="element-248">
                <span className="text-[#a0aec0]" data-id="element-249">$19.990</span>
              </div>
              <div className="text-center flex justify-center items-center" data-id="element-250">
                <span className="text-[#d4af37] font-bold" data-id="element-251">$29.990</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-xl p-6 text-center" data-id="element-252">
          <p className="text-xl text-white font-medium mb-2" data-id="element-253">
            💡 Solo{' '}
            <span className="text-[#d4af37] font-bold" data-id="element-254">$10.000 ARS</span> más.
          </p>
          <p className="text-[#e2e8f0]" data-id="element-255">
            El Cerebro Clínico del AT por separado vale $19.990 ARS.
          </p>
          <p className="text-[#e2e8f0]" data-id="element-256">
            Agregándolo ahora lo llevás a la mitad del precio.
          </p>
        </div>
      </motion.div>
    </section>;
}